import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da1dbfc0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=da1dbfc0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da1dbfc0')) {
      api.createRecord('da1dbfc0', component.options)
    } else {
      api.reload('da1dbfc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=da1dbfc0", function () {
      api.rerender('da1dbfc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/index.vue"
export default component.exports